export default __webpack_public_path__ + "static/media/CCS_cloudxier1.24fa65a5.png";